<template>
  <div class="animated fadeIn">

    
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>

      <div class="modal fade show " id="modal-mapa" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMapa">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <a class="close" data-dismiss="modal" aria-label="Fechar" style=" z-index: 1000000; font-size: 69px; color: #000; float: right; right: 0; position: absolute; top: -40px; opacity: 1;" v-on:click="showModalMapa = false">
                <span aria-hidden="true">&times;</span>
              </a>
              <gmap-map
                :center="center"
                :zoom="15"
                ref="map"
                :options="{ gestureHandling: 'greedy'}"
                style="width:calc(100vw - 28px);  height: calc(100vh - 64px)"
              >
                <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                  <span v-html="infoContent"></span>
                </gmap-info-window>
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  @click="toggleInfoWindow(m,index)"
                ></gmap-marker>
                <gmap-polyline v-if="path.length > 0" :path="path" :editable="false"
                    ref="polyline">
                </gmap-polyline>
              </gmap-map>  
              
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
            </div> -->
          </div>
        </div>
      </div>

      <PontoCadastro @eventname="updateparent" v-bind:showModalPonto.sync="showModalPonto" v-bind:latitude="pontoCadastroLat" v-bind:longitude="pontoCadastroLng"></PontoCadastro>
        
      <span id="imprimirLinks"> </span>

      <div id="relatorio" class="card">
        <div class="card-title">
          <strong></strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h3>Relatório de Posições</h3>
            </div>
            <div class="col-md-6 text-right">
              <button class="btn btn-success" v-on:click="generateReport()">Download PDF</button>
              <download-excel
                class   = "btn btn-default"
                :fields = "fieldsDadosRelatorios"
                :data   = "dadosRelatorios.dados"
                :title = "'Data: '+dadosRelatorios.data + '\n  Veículo: ' + dadosRelatorios.veiculo +  '\n  Empresa: ' + dadosRelatorios.empresa + '\n\n' + '  Distância Percorrida: ' + formatarVelocidade(dadosRelatorios.distanciaPercorrida) + 'Km' + '\n  Odômetro do GPS: ' + formatarVelocidade(dadosRelatorios.distanciaPercorridaOdometro) + ' Km ' + '\n  Velocidade Média: ' + formatarVelocidade(dadosRelatorios.velocidadeMedia) + ' Km/h ' + '\n  Velocidade Máxima: ' + formatarVelocidade(dadosRelatorios.velocidadeMaxima) + ' Km/h ' "
                :footer = "dadosRelatorios.data"
                worksheet = "My Worksheet"
                name    = "filename.xls">
                <button class="btn btn-success">Download XLS</button>
              </download-excel>

              <button class="btn btn-success" v-on:click="visualizarMapa()">Ver no Mapa</button>
              <router-link id="btnNovoVeiculo" class="btn btn-danger" to="/relatorios">
                <span class="glyphicon glyphicon-plus"></span> Fechar
              </router-link>
            </div>
          </div>
          <div class="row" style="margin-top: 12px; margin-bottom: 12px;">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <strong>Data: </strong>{{dadosRelatorios.data}}
                </div>
                <div class="col-md-3">
                  <strong>Veículo: </strong> {{dadosRelatorios.veiculo}}
                </div>
                <div class="col-md-5">
                  <strong>Empresa: </strong>{{dadosRelatorios.empresa}}
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <strong>Distância Percorrida: </strong>{{formatarVelocidade(dadosRelatorios.distanciaPercorrida)}} Km<br>
                  <strong>Odômetro do GPS: </strong>{{formatarVelocidade(dadosRelatorios.distanciaPercorridaOdometro)}} Km
                </div>
                <div class="col-md-3">
                  <strong>Velocidade Média: </strong>{{formatarVelocidade(dadosRelatorios.velocidadeMedia)}} Km/h
                </div>
                  <div class="col-md-5">
                  <strong>Velocidade Máxima: </strong>{{formatarVelocidade(dadosRelatorios.velocidadeMaxima)}} Km/h
                </div>
              </div>
            </div>
          </div>

          <template v-if="processando === false">
            <template v-if="dadosRelatorios.dados.length > 0">
              <table class="table table-responsive-sm table-hover table-outline mb-0">
                <thead class="thead-light">
                  <tr>
                    <th width="80">HORA</th>
                    <th>PONTO MAIS PROXIMO</th>
                    <th width="120">VELOCIDADE</th>
                    <th width="120">DESLOCAMENTO</th>
                    <th width="65">IGNIÇÃO</th>
                    <th width="50">GPS</th>
                    <th width="50">GPRS</th>
                    <th width="50">MOV</th> 
                    <th width="50">VOLT</th>
                    <th width="70">MOT T</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dados, i) in dadosRelatorios.dados" :class="{ 'selecionado': selecionado(dados) }" @click="selecionarItem(dados, $event)" >
                    <td>
                      <input :id="'latitude_'+i" type="hidden" v-model="dados.latitude" />
                      <input :id="'longitude_'+i" type="hidden" v-model="dados.longitude" />
                      <small class="text-muted">{{dados.hora}}</small></td>
                    <td><small class="text-muted">{{dados.pontoMaisProximo}}</small></td>
                    <td>
                      <template v-if="dados.alertaVelocidade === 'true'"> 
                        <small class="text-danger"><strong>{{formatarVelocidade(dados.velocidade)}} Km/h</strong></small>
                      </template>
                      <template v-else> 
                        <small class="text-muted">{{formatarVelocidade(dados.velocidade)}} Km/h</small>
                      </template>
                    </td>
                    <td><small class="text-muted">{{dados.deslocamento}} Km</small></td>
                    <td>
                      
                      <template v-if="dados.ignicaoDesativada">
                        <img src="/static/images/disable.png" />
                      </template>
                      <template v-else>
                        <template v-if="dados.ignicao">
                          <img src="/static/images/true.png" />
                        </template>
                        <template v-else>
                          <img src="/static/images/false.png" />
                        </template>
                      </template>
                    </td>
                    <td>
                      <template v-if="dados.gpsDesativada">
                        <img src="/static/images/disable.png" />
                      </template>
                      <template v-else>
                        <template v-if="dados.gps">
                          <img src="/static/images/true.png" />
                        </template>
                        <template v-else>
                          <img src="/static/images/false.png" />
                        </template>
                      </template>
                    </td>
                    <td>
                      <template v-if="dados.gprsDesativada">
                        <img src="/static/images/disable.png" />
                      </template>
                      <template v-else>
                        <template v-if="dados.gprs">
                          <img src="/static/images/true.png" />
                        </template>
                        <template v-else>
                          <img src="/static/images/false.png" />
                        </template>
                      </template>
                    </td>
                    <td>
                      <template v-if="dados.movimentoDesativada">
                        <img src="/static/images/disable.png" />
                      </template>
                      <template v-else>
                        <template v-if="dados.movimento">
                          <img src="/static/images/true.png" />
                        </template>
                        <template v-else>
                          <img src="/static/images/false.png" />
                        </template>
                      </template>
                    </td>
                    <td>
                      <template v-if="dados.alertaTensao === 'true'"> 
                        <small class="text-warning"><strong>{{dados.tensao}}</strong></small>
                      </template>
                      <template v-else> 
                        <small class="text-muted">{{dados.tensao}}</small>
                      </template>
                    </td>
                    <td>
                      <small class="text-muted">{{dados.motivoTransmissao}}</small>
                      <template v-if="dados.motorista !== ''"><small class="text-muted">{{dados.motorista}}</small></template>
                    </td>
                  </tr>
                </tbody>
                
              </table>
            </template>          
            <template v-else>
              <div id="relatorio-sem-dados">
                <h1><bold>Sem dados para o período</bold></h1>
              </div>
            </template>
          </template>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNdW9zNp4aaHrlBIX8r7YnB3Axv4kvDv0"></script>
<script>
import axios from 'axios'
import PontoCadastro from './PontoCadastro.vue'
import Blob from 'blobjs'
export default {
  components: {
    PontoCadastro
  },
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      fieldsDadosRelatorios: {
        'Data': 'data',
        'Hora': 'hora',
        'Ponto Mais Próximo': 'pontoMaisProximo',
        'Velocidade': {
          field: 'velocidade',
          callback: (value) => {
            return this.formatarVelocidadeMetros(value)
          }
        },
        'Deslocamento': {
          field: 'deslocamento',
          callback: (value) => {
            return this.formatarVelocidadeMetros(value)
          }
        },
        'Ignição': 'ignicao',
        'GPS': 'gps',
        'GPRS': 'gprs',
        'Movimento': 'movimento',
        'Volt': {
          field: 'tensao',
          callback: (value) => {
            return this.formatarVelocidadeMetros(value)
          }
        },
        'Motivo Transmissão': 'motivoTransmissao'
      },
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      showModalPonto: false,
      pontoCadastroLat: 0,
      pontoCadastroLng: 0,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    }
  },
  mounted () {
    this.buscarRelatorio()
  },
  created () {
    window.cadastrarPonto = this.cadastrarPonto
  },
  methods: {
    selecionarItem: function (item, event) {
      this.selecionada = item.id
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados.push(item)
        }
      } else {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados = []
          this.selecionados.push(item)
        }
      }
      this.selecionados = this.selecionados.sort((a, b) => b.id - a.id)
    },
    selecionado: function (item) {
      return this.selecionados.includes(item)
    },
    buscarRelatorio: function () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculoId
      var dataHoraInicial = this.$route.params.dataHoraInicial
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataHoraFinal
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/')
      var filtroVelocidade = this.$route.params.filtroVelocidade
      var desprezarVelocidade = this.$route.params.desprezarVelocidade
      var agruparPosicoes = this.$route.params.agruparPosicoes
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosRelatorios = dadosCadastro
        self.processando = false
        self.markers = []
        self.path = []
        self.removerMarkers()
      })
    },
    async visualizarMapa () {
      let self = this
      self.removerMarkers()
      self.showModalMapa = true
      await new Promise(resolve => setTimeout(resolve, 2000))
      self.adicionarMarkers()
    },
    adicionarMarkers () {
      let self = this
      self.removerMarkers()
      let bounds = null
      let myLatLng = null
      if (self.selecionados.length > 0) {
        for (let i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            let marker = {}
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              }
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo })
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            })
            // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            self.center = marker
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds()
            }
            bounds.extend(myLatLng)
            // this.$refs.map.fitBounds(bounds)
            // self.$refs.map.fitBounds(bounds)
          }
        }
      } else {
        for (let i = 0; i < self.dadosRelatorios.dados.length; i++) {
          console.log(self.dadosRelatorios.dados[i].latitude)
          if (self.dadosRelatorios.dados[i].latitude !== 0) {
            let marker = {}
            if (self.dadosRelatorios.dados[i].latitude !== '0') {
              marker = {
                lat: self.dadosRelatorios.dados[i].latitude,
                lng: self.dadosRelatorios.dados[i].longitude
              }
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[i].hora, ignicao: self.dadosRelatorios.dados[i].ignicao, velocidade: self.dadosRelatorios.dados[i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[i].pontoMaisProximo })
            self.path.push({
              lat: self.dadosRelatorios.dados[i].latitude,
              lng: self.dadosRelatorios.dados[i].longitude
            })
            // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            self.center = marker
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds()
            }
            bounds.extend(myLatLng)
            // self.$refs.map.fitBounds(bounds)
            // self.selecionados.push(self.dadosGrid[i].idVeiculo)
          }
        }
      }
      self.$nextTick(() => {
        console.log(bounds)
        self.setMapBounds()
        // self.$refs.map.$mapCrecadastrarPontoated.then(() => {
        //   self.$refs.map.$mapObject.fitBounds(bounds)
        // })
      })
      // this.$refs.map.$mapPromise.then(() => {
      //   console.log(bounds)
      //   this.$refs.map.$mapObject.fitBounds(bounds)
      // })
      // self.center = marker
      self.currentPlace = null
      // self.$refs.map.fitBounds(self.markers)
      // })
    },
    removerMarkers () {
      let self = this
      self.markers = []
      self.path = []
    },
    setMapBounds () {
      let self = this
      var bounds = new window.google.maps.LatLngBounds()
      for (let i = 0; i < this.markers.length; i++) {
        let myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng })
        bounds.extend(myLatLng)
      }
      // this.markers.forEach(marker => {
      //   bounds.extend(new window.google.maps.LatLng(marker.position.lat, marker.position.lng))
      // })
      setTimeout(function () {
        self.$refs.map.fitBounds(bounds)
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18)
        }
      }, 500)
      // console.log(self.$refs.map.getZoom())
      console.log(self.$refs.map.$mapObject.zoom)
      console.log(self.$refs.map.zoom)
      // this.$refs.map.$mapCreated.then((map) => {
      //   map.fitBounds(bounds)
      // })
      // Vue.$gmapDefaultResizeBus.$emit("resize")
    },
    cadastrarPonto (lat, lng) {
      this.pontoCadastroLat = lat
      this.pontoCadastroLng = lng
      this.showModalPonto = true
    },
    updateparent () {
      this.showModalPonto = false
    },
    generateReport () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculoId
      var dataHoraInicial = this.$route.params.dataHoraInicial
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataHoraFinal
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/')
      var filtroVelocidade = this.$route.params.filtroVelocidade
      var desprezarVelocidade = this.$route.params.desprezarVelocidade
      var agruparPosicoes = this.$route.params.agruparPosicoes
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/relatorios/relatorioDePosicoesPdf?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes + '&zoomMapa=8'
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
        self.processando = false
        self.botaoProcessando = false
      })
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>' + '<br>Ponto: <span onClick="cadastrarPonto(' + marker.position.lat + ',' + marker.position.lng + ')" style="cursor: hand;cursor: pointer;" ><strong>Cadastrar ponto</strong></span>'
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/relatorios/RelatorioDePosicoesView.vue